/** Dispatched on `window` when a tenant realtime payload is received (Web PubSub). */
export const MEASUREMENT_APP_EVENT = 'blecho-measurement-app-event';

export const MEASUREMENT_CREATION_EVENT_TYPE = 'measurement.creation';
